export default "__VITE_ASSET__e5d28141__"